import { useCallback, useMemo, useState, type ReactNode } from 'react';
import { CommandPaletteContext } from './useCommandPaletteContext';

/** Open state of the ⌘K palette, so the header button and the keyboard share it. */
export const CommandPaletteProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [open, setOpen] = useState(false);
  const toggle = useCallback(() => setOpen((prev) => !prev), []);
  const value = useMemo(() => ({ open, setOpen, toggle }), [open, toggle]);
  return (
    <CommandPaletteContext.Provider value={value}>
      {children}
    </CommandPaletteContext.Provider>
  );
};
